import { z } from 'zod';
export const createOrgSchema = z.object({
    name: z
        .string()
        .min(2, 'Organization name must be at least 2 characters')
        .max(64, 'Organization name must be at most 64 characters')
        .trim(),
    slug: z
        .string()
        .min(2, 'Slug must be at least 2 characters')
        .max(32, 'Slug must be at most 32 characters')
        .regex(/^[a-z0-9-]+$/, 'Slug must contain only lowercase letters, numbers, and hyphens'),
});
// `allowPublicChannels` used to be accepted here but was never persisted:
// public channels were removed (migration 20260415000000) and org settings
// carry no such flag. Unknown keys are stripped by zod, so older clients that
// still send it get a clean 200 rather than a silent no-op on a field that
// looks supported.
export const updateOrgSchema = z.object({
    name: z.string().min(2).max(64).trim().optional(),
});
export const inviteToOrgSchema = z.object({
    email: z.string().email('Invalid email address'),
});
export const createOrgInviteSchema = z.object({
    expiresAt: z.union([z.string().datetime({ offset: true }), z.null()]).optional(),
    maxUses: z.union([z.coerce.number().int().positive(), z.null()]).optional(),
});
//# sourceMappingURL=org.schema.js.map